module.exports = __webpack_public_path__ + "img/1440.b3410711.jpg";